export default __webpack_public_path__ + "static/media/thumbnail_4.e760038f.webp";